import { styled } from '@mui/system';
import Box from '@mui/material/Box';

/**
 * A styled Box component used for rendering tooltips.
 * It applies custom styling such as box shadow, border radius, background color,
 * and sets the maximum width and height for the tooltip.
 *
 * @component
 * @returns {JSX.Element}
 */
const TooltipBox = styled(Box)(({ theme }) => ({
    boxShadow: '1px 2px 10px -2px rgba(102,102,102,0.68)',
    borderRadius: '10px',
    backgroundColor: theme.palette.common.white,
    maxWidth: 320,
    maxHeight: 300,
    position: 'absolute',
    zIndex: 40
}));

export default TooltipBox;
